import { createTheme } from '@mui/material/styles';

const palette = {
  navy: '#0B1426',
  navyLight: '#152238',
  slate: '#1E2D45',
  gold: '#C9A962',
  goldLight: '#E8D5A3',
  ice: '#F7F9FC',
  mist: '#E8EDF5',
  text: '#1A2332',
  textMuted: '#5A6B82',
};

export const brandColors = palette;

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: palette.navy,
      light: palette.navyLight,
      dark: '#060D18',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: palette.gold,
      light: palette.goldLight,
      dark: '#A68B42',
      contrastText: palette.navy,
    },
    background: {
      default: palette.ice,
      paper: '#FFFFFF',
    },
    text: {
      primary: palette.text,
      secondary: palette.textMuted,
    },
    divider: palette.mist,
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Segoe UI", sans-serif',
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.03em',
      lineHeight: 1.1,
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.02em',
      lineHeight: 1.2,
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: {
      fontWeight: 500,
      lineHeight: 1.6,
    },
    body1: { lineHeight: 1.7 },
    body2: { lineHeight: 1.65 },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: '0.01em',
    },
  },
  shape: { borderRadius: 14 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { overflowX: 'clip' },
        body: { overflowX: 'clip', maxWidth: '100vw' },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          width: '100%',
          boxSizing: 'border-box',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '10px 22px',
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedPrimary: {
          background: `linear-gradient(135deg, ${palette.navy} 0%, ${palette.slate} 100%)`,
        },
        containedSecondary: {
          color: palette.navy,
          fontWeight: 700,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          border: `1px solid ${palette.mist}`,
          boxShadow: '0 4px 24px rgba(11, 20, 38, 0.06)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;
